import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import logo from '../logo-big-transparent.png';

const Footer = () => {
  
    const scrollWithOffset = (el) => {
      const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
      // Adjust this offset value (e.g., 90, 100, 120) based on your header's height
      // and how much background space you want above the section.
      const yOffset = -75; // Negative value to scroll UP by 90 pixels
  
      window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  
      // Close mobile menu if open after clicking a link (if applicable for HashLink)
    };

  return (
    <footer className="py-12 px-6 bg-black bg-opacity-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* <div className="flex items-center space-x-2 mb-6 md:mb-0">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-devcore.primary to-blue-400 flex items-center justify-center">
              <span className="font-bold text-xl">D</span>
            </div>
            <span className="text-2xl font-bold gradient-text">DEVCORE</span>
          </div> */}
          <Link to="/" className="flex items-center"> {/* Use Link for navigation to home */}
            {/* Adjust h-X (e.g., h-14, h-16) to make the logo bigger. */}
            {/* w-auto will ensure it maintains its aspect ratio. */}
            <img src={logo} alt="DEVCORE Logo" className="h-8 w-auto object-contain" />
            {/* If you want the "DEVCORE" text next to the logo, uncomment this line: */}
            {/* <span className="text-2xl font-bold gradient-text ml-2">DEVCORE</span> */}
          </Link>

          <div className="flex flex-wrap justify-center gap-6 mb-6 md:mb-0">
            {/* <a href="#home" className="text-gray-300 hover:text-devcore.primary transition">Home</a>
            <a href="#scripts" className="text-gray-300 hover:text-devcore.primary transition">Scripts</a>
            <a href="#docs" className="text-gray-300 hover:text-devcore.primary transition">Documentation</a>
            <a href="#team" className="text-gray-300 hover:text-devcore.primary transition">Team</a>
            <a href="https://your-existing-store.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-devcore.primary transition">Store</a> */}
            <Link to="/" className="text-gray-300 hover:text-devcore.primary transition">Home</Link>
            <Link to="/scripts" className="text-gray-300 hover:text-devcore.primary transition">Scripts</Link>
            <Link to="/docs" className="text-gray-300 hover:text-devcore.primary transition">Documentation</Link>
            <HashLink smooth to="/#team" scroll={scrollWithOffset} className="text-gray-300 hover:text-devcore.primary transition">Team</HashLink>
            <a href="https://store.devcore.cz" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-devcore.primary transition">
              <span>Store</span>
              {/* <i className="fas fa-external-link-alt text-sm"></i> */}
            </a>
          </div>

          <div className="flex space-x-4">
            <a href="https://github.com/DEVCORECZ" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-devcore.primary transition">
              <i className="fab fa-github text-xl"></i>
            </a>
            <a href="https://discord.gg/zcG9KQj3sa" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-devcore.primary transition">
              <i className="fab fa-discord text-xl"></i>
            </a>
            {/* <a href="#" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-devcore.primary transition"> */}
              {/* <i className="fab fa-twitter text-xl"></i> */}
            {/* </a> */}
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2025 DEVCORE Studios. All rights reserved.</p>
          <p className="mt-2 text-sm">Premium FiveM scripts, designed for your ultimate gameplay.</p>
          <p className="mt-4 text-xs text-gray-500 italic">
            Crafted with 💙 and precision by Jiricech2059 (jiricech2059@gmail.com).
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;